import { toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { useEffect, useState } from "react";
import { Card, Form } from "react-bootstrap";
import axiosInstance from '../../../../hooks/axiosInstance';

export default function CreateCheckoutOrder({
    showCheckout,
    closeModal,
    refreshPage,
    CheckOutData,
}) {
    const [orderInfo, setOrder] = useState(null);

    const handleClose = () => {
        refreshPage();
        closeModal();
    };

    useEffect(() => {
        console.log(CheckOutData);

        if (CheckOutData) {
            setOrder(CheckOutData);
        }

    }, [CheckOutData]);

    const handleApprove = async () => {
        try {
            const apiUrl = '/user/check_out/create';
            const approveFormData = new FormData();
            approveFormData.append('category_id', orderInfo.category_id);
            approveFormData.append('order_id', orderInfo.order_id);
            approveFormData.append('order_code', orderInfo.order_code);
            approveFormData.append('sub_category_id', orderInfo.sub_category_id);
            approveFormData.append('product_id', orderInfo.product_id);
            approveFormData.append('batch_number', orderInfo.batch_number);
            approveFormData.append('quantity', orderInfo.quantity);
            approveFormData.append('ware_house_id', orderInfo.ware_house_id);

            await axiosInstance.post(apiUrl, approveFormData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });

            toast.success("Order approved successfully!");
            refreshPage();
            handleClose();
        } catch (error) {
            console.error("Error approving order:", error);

            // Check if error response contains an 'error' key and display it
            if (error.response && error.response.data) {
                const errorMessage = error.response.data.error;

                if (errorMessage) {
                    toast.error(errorMessage); // Display the general error message
                } else {
                    toast.error("An error occurred while approving the order.");
                }
            } else {
                toast.error("An error occurred while approving the order.");
            }
        }
    };

    const orderDetails = orderInfo ? (
        <Card className="mb-3">
            <Card.Body>
                <strong>Company Name:</strong> {orderInfo.company_name}
                <br />
                <strong>Product Name:</strong> {orderInfo.product_name}
                <br />
                <strong>Category:</strong> {orderInfo.category_name}
                <br />
                <strong>Sub-Category:</strong> {orderInfo.sub_category_name}
                <br />
                <strong>Quantity:</strong> {orderInfo.quantity}
                <br />
                <strong>WareHouse:</strong> {orderInfo.ware_house_name}

                <br />
            </Card.Body>
        </Card>
    ) : (
        <p>No order details available.</p>
    );

    return (
        <div className="ViewTransaction">
            <Modal show={showCheckout} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Check-Out</Modal.Title>
                </Modal.Header>
                <Modal.Body style={{ fontSize: "15px", lineHeight: "30px" }}>
                    {orderDetails}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="info" onClick={handleApprove}>
                        Approve
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
}
